var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 6,
    fill: "#F5FFF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 6.99951C17.4477 6.99951 17 7.44723 17 7.99951C17 8.5518 17.4477 8.99951 18 8.99951H20C20.5523 8.99951 21 8.5518 21 7.99951C21 7.44723 20.5523 6.99951 20 6.99951H18ZM19 29.5002C14.1675 29.5002 10.25 25.5827 10.25 20.7502C10.25 15.9178 14.1675 12.0002 19 12.0002C19.29 12.0002 19.5765 12.0143 19.8589 12.0418L20.0042 10.5489C19.6736 10.5167 19.3386 10.5002 19 10.5002C13.3391 10.5002 8.75 15.0893 8.75 20.7502C8.75 26.4112 13.3391 31.0002 19 31.0002C24.6609 31.0002 29.25 26.4112 29.25 20.7502C29.25 20.4116 29.2336 20.0767 29.2014 19.7461L27.7084 19.8914C27.7359 20.1737 27.75 20.4602 27.75 20.7502C27.75 25.5827 23.8325 29.5002 19 29.5002ZM28.0411 15.9171C28.3555 16.5041 28.6145 17.1255 28.8111 17.7741L27.3755 18.2091C27.208 17.6561 26.9871 17.1262 26.7188 16.6253L28.0411 15.9171ZM25.503 12.8269C26.0215 13.2529 26.4974 13.7288 26.9234 14.2473L25.7644 15.1995C25.4004 14.7565 24.9937 14.3498 24.5507 13.9859L25.503 12.8269ZM21.9761 10.9392C22.6248 11.1357 23.2461 11.3947 23.8332 11.7092L23.1249 13.0314C22.624 12.7631 22.0941 12.5423 21.5412 12.3748L21.9761 10.9392ZM25.4672 19.0715C25.8189 19.9207 26 20.831 26 21.7502H19V14.7502C19.9193 14.7502 20.8295 14.9313 21.6788 15.2831C22.5281 15.6349 23.2997 16.1505 23.9497 16.8005C24.5998 17.4505 25.1154 18.2222 25.4672 19.0715Z",
    fill: "#38D200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTimer);
export default __webpack_public_path__ + "static/media/green_timer.b748afebc07b5a8d9f244a386111d1a3.svg";
export { ForwardRef as ReactComponent };